jQuery(document).ready(function($) {

	// Trigger the shop loop orderby form on select change
	$( '.woocommerce-ordering' ).on( 'change', 'select', function() {
		$( this ).closest( 'form' ).trigger( 'submit' );
	});

});